module.exports = __webpack_public_path__ + "img/error_404.2f3715ee.png";